import React, { useState, useEffect } from 'react';
import { Button, Col, ConfigProvider, Dropdown, Form, Menu, Radio, Row, Space, Tag, Timeline } from "antd";
import { errorCatch, READWITH, QueryDetail, QueryParam, JSXMap, IfElse, QueryOrder, HasAnswer, GetAnswer, GET, GETWITH, QueryParams, JSXPathMap, getAnswerValue, getAnswersFromContext, If, funcClient, answersClearAll, JSX } from '../../components/Tool'
import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../../components/Auth';
import { useContext, useServiceContext, useSetContext, useUserContext } from '../../components/Context';
import Question from '../Question';
import ServiceDone from '../ServiceDone';
import Action, { FooterButton } from '../../components/Action';
import Sider from 'antd/lib/layout/Sider';
import Layout, { Content } from 'antd/lib/layout/layout';
import Icofont from 'react-icofont';
import "./index.less";
import uuid from 'react-uuid';

var _ = require('lodash');
const { CheckableTag } = Tag;

export default function ServiceParameters(props) {
    let { id } = useParams();
    const auth = useAuth();
    const user = useUserContext();
    const context = useContext();
    const setContext = useSetContext();
    const service = useServiceContext();
    const [questions, setQuestions] = useState();
    const [fsm, setFsm] = useState();
    const [funcs, setFuncs] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (context && service) {
            GETWITH(auth, `/api/context/state/context/${context.ID}/service/${service.ID}`, [
                QueryDetail("model")
            ], ({ data }) => {
                setFsm(data);
            }, errorCatch);
            READWITH(auth, "QuestionsServices",
                [
                    QueryDetail("model"),
                    QueryParam("w-service.ID", service.ID),
                    QueryOrder("sorting", "ASC")
                ],
                ({ data }) => {
                    const filter = (e) => {
                        let f = context.contextAnswerContext.filter(a => a.questionID === e.questionID);
                        if (f && f.length == 0) {
                            return undefined
                        }
                        return f;
                    };
                    let tmp = data.map(e => ({
                        ...e,
                        answer: (e.question.answerTypeID !== 9) ? context.contextAnswerContext.reverse().find(a => a.questionID === e.questionID) : filter(e)
                    }))
                    let q = tmp.filter(e => e.answer);
                    setQuestions(q)
                },
                errorCatch
            );
        }
    }, [context, service]);

    useEffect(() => {
        if (fsm) {
            let allfuncs = _.get(fsm, "currentState.fsmSchemeCurrentState");
            if (allfuncs) {
                let fun = allfuncs.filter(e => e.fsmFunction.isClient === true);
                setFuncs(fun);
            }
        }
    }, [fsm]);

    const onQuestionChange = (fsm) => {
        setFsm(fsm);
        setContext(fsm.context);
    };
    const isDone = (context) => {
        return fsm && fsm.currentState.terminal == true;
    };

    const actionFunc = React.useMemo(() => (values, unlock, close, properties) => {
        let func = funcs.find(e => e.fsmFunctionID === values.functions.id)
        if (!isDone(context) && func) {
            funcClient(auth, context, service.ID, values.functions.id, func.question, Object.values(values.question), onQuestionChange, {
                lock: () => setLoading(true),
                unlock: () => {
                    unlock();
                    setLoading(false)
                },
            });
        }
    }, [context, service, funcs]);
    const funcsWithMaxQuestion = (funcs) => {
        let s = _.maxBy(funcs, function (e) { return e.fsmFunction.questionID; })
        if (s) {
            return s.fsmFunction.ID
        }
    };
    const steps = React.useMemo(() => ([
        {
            key: "functions",
            name: "Шаг 1",
            action: (values, unlock, close) => {
                close(values);
            },
            form: (props) => {
                const { auth, form } = props;
                return <div>
                    <Form
                        form={form}
                        onFinish={props.submit}
                        labelAlign={"left"}
                        layout={"vertical"}
                        initialValues={{
                            id: funcsWithMaxQuestion(funcs)
                        }}
                    >
                        {fsm && <div style={{ paddingBottom: "10px" }}>
                            <span className="state-description">{fsm.currentState.description}</span>
                        </div>}
                        <div style={{ paddingBottom: "5px" }}>Возможные действия:</div>
                        <Form.Item
                            name="id"
                            rules={[{ required: true, message: 'Пожалуйста, укажите значение!' }]}
                        >
                            <Radio.Group size='large'>
                                <Space direction="vertical">
                                    {JSXMap(funcs, (e, idx) => (
                                        <Radio key={idx} style={{ fontSize: "18px" }} value={e.fsmFunction.ID}>{e.fsmFunction.description}</Radio>
                                    ))}
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </div>
            },
        },
        {
            key: "question",
            name: "Шаг 2",
            form: (props) => {
                return <Question auth={props.auth} form={props.form} submit={props.submit} fun={funcs.find(e => e.fsmFunctionID === props.data.functions.id)} context={context} onQuestionChange={onQuestionChange} />
            },
        }
    ]), [funcs, fsm]);

    const backFsm = () => {
        if (context && service) {
            GET(auth, `/api/context/state/back/context/${context.ID}/service/${service.ID}`,
                ({ data }) => {
                    setFsm(data);
                    setContext(data.context);
                },
                errorCatch
            );
        }
    };

    return (<>
        <Layout style={{ backgroundColor: "white", paddingTop: "15px" }}>
            <Content>
                <ConfigProvider componentSize={"large"}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div>
                                {If(funcs.length == 1, (<>
                                    <Action
                                        mode={"inline"}
                                        auth={auth}
                                        okText="Далее"

                                        fun={_.get(funcs, "[0]")}
                                        context={context}
                                        onQuestionChange={onQuestionChange}
                                        key={(fsm) ? fsm.ID : uuid()}
                                        form={Question}
                                        footerExtendedButtons={({ DismissFunction: cancel, OkFunction: ok, mode, loading }) => {
                                            if (mode === "inline" && !cancel) {
                                                return [
                                                    {
                                                        key: "backFsm",
                                                        name: 'Назад',
                                                        callback: backFsm,
                                                        options: {
                                                            type: "ghost"
                                                        }
                                                    }
                                                ]
                                            }
                                            return []
                                        }}
                                        action={(values, unlock, close, properties) => {
                                            if (!isDone(context)) {
                                                funcClient(auth, context, service.ID, _.get(funcs, "[0].fsmFunction.ID"), _.get(funcs, "[0].fsmFunction.question"), Object.values(values), onQuestionChange, {
                                                    lock: () => setLoading(true),
                                                    unlock: () => {
                                                        unlock();
                                                        setLoading(false)
                                                    },
                                                });
                                            }
                                        }}
                                    />
                                </>))}
                                {If(funcs.length > 1, (<>
                                    <Action
                                        mode={"inline"}
                                        auth={auth}
                                        okText="Далее"
                                        action={actionFunc}
                                        steps={steps}
                                        key={(fsm) ? fsm.ID : uuid()}
                                        footerExtendedButtons={({ DismissFunction: cancel, OkFunction: ok, mode, loading }) => {
                                            if (mode === "inline" && !cancel) {
                                                return [
                                                    {
                                                        key: "backFsm",
                                                        name: 'Назад',
                                                        callback: backFsm,
                                                        options: {
                                                            type: "ghost"
                                                        }
                                                    }
                                                ]
                                            }
                                            return []
                                        }}
                                    />
                                </>))}
                            </div>
                        </Col>
                    </Row>
                    {isDone(context) && <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px", paddingBottom: "35px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Все необходимые параметры для подбора сортов и гибридов определены. </div>
                                <div>Теперь можно выполнить подбор сорта и просмотреть отчет.</div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Подбор сорта</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row>}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение норм и способов внесения удобрений и мелиорантов завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                Планируется внесение <span style={{textDecoration: "underline"}}>макроудобрений</span> в дозе <span style={{textDecoration: "underline"}}>под основную обработку почвы</span> 
                                N <span style={{textDecoration: "underline"}}>30</span> P <span style={{textDecoration: "underline"}}>30</span> K <span style={{textDecoration: "underline"}}>30</span> (в кг.д.в.), а также подкормки по вегетации растений в 
                                количестве <span style={{textDecoration: "underline"}}>1 раза</span> (<span style={{textDecoration: "underline"}}>вразброс</span>) в дозе N <span style={{textDecoration: "underline"}}>30</span> (в кг.д.в.). Подбор техники не 
                                производился.
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение норм и способов внесения удобрений и мелиорантов завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Погрузка органических удобрений (<span style={{ textDecoration: "underline" }}>навоз подстилочный</span>)</td>
                                                <td>Подбор не производился</td>
                                                <td>Подбор не производился</td>
                                                <td><span style={{ textDecoration: "underline" }}>20</span> т/га</td>
                                            </tr>
                                            <tr>
                                                <td>Доставка и внесение органических удобрений (<span style={{ textDecoration: "underline" }}>навоз подстилочный</span>)</td>
                                                 <td>Подбор не производился</td>
                                                <td>Подбор не производился</td>
                                                <td><span style={{ textDecoration: "underline" }}>20</span> т/га</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение норм и способов внесения удобрений и мелиорантов завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Погрузка минеральных удобрений</td>
                                                <td>Подбор не производился</td>
                                                <td>Подбор не производился</td>
                                                <td>
                                                    N<span style={{ textDecoration: "underline" }}>36</span>
                                                    P<span style={{ textDecoration: "underline" }}>55</span>
                                                    K<span style={{ textDecoration: "underline" }}>77</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Доставка и внесение минеральных удобрений </td>
                                                <td>Указывается модель</td>
                                                <td>Указывается модель, либо несколько машин через «+»</td>
                                                <td>
                                                    N<span style={{ textDecoration: "underline" }}>36</span>
                                                    P<span style={{ textDecoration: "underline" }}>55</span>
                                                    K<span style={{ textDecoration: "underline" }}>77</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение способа основной обработки почвы завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Поверхностная обработка (до 12 см)</td>
                                                <td>МТЗ 1221</td>
                                                <td>БДМ 3х2</td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение способа основной обработки почвы завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Cредняя отвальная (до 20-24 см)</td>
                                                <td>Подбор не производился</td>
                                                <td>Подбор не производился</td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение способа предпосевной обработки семян завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Предпосевная обработка семян</td>
                                                <td>Не требуется</td>
                                                <td>ПС-10</td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение способа посева завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Посев <span style={{ textDecoration: "underline" }}>без</span> внесения удобрений</td>
                                                <td>МТЗ-82.1</td>
                                                <td>СЗ-5.4</td>
                                                <td>
                                                    Рекомендуемая норма высева
                                                    - <span style={{ textDecoration: "underline" }}>0,20</span> т/га
                                                    (<span style={{ textDecoration: "underline" }}>5,5</span> млн.шт./га)
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение ранневесенних мероприятий завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Погрузка и доставка минеральных удобрений </td>
                                                <td>-</td>
                                                <td>ГАЗ-САЗ 2507-01</td>
                                                <td>
                                                <span style={{ textDecoration: "underline" }}>0,1</span> т/га
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Подкормка посевов </td>
                                                <td>МТЗ-82.1</td>
                                                <td>РУМ-800</td>
                                                <td>
                                                <span style={{ textDecoration: "underline" }}>0,1</span> т/га
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Ранневесеннее боронование озимых</td>
                                                <td>Подбор не проводился</td>
                                                <td>Подбор не проводился</td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение способа ухода за посевами завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Подвоз воды </td>
                                                <td>-</td>
                                                <td>ГАЗ-САЗ 2507-01 + Кассета 4000 литров</td>
                                                <td>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Обработка посевов пестицидами (в случае совместного применения подкормки и пестицидов – это Обработка посевов пестицидами и листовая подкормка)</td>
                                                <td>МТЗ-82.1</td>
                                                <td>ОПШ 2000-24</td>
                                                <td>
                                                Препарат <span style={{ textDecoration: "underline" }}>Фенизан</span>. Норма 
                                                внесение – <span style={{ textDecoration: "underline" }}>0,2</span> л/га. Расход рабочей 
                                                жидкости – <span style={{ textDecoration: "underline" }}>300</span> л/га.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение способа уборки завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Прямое комбайнирование</td>
                                                <td>Не требуется</td>
                                                <td>КЗС-812 + ЖЗК-7-5</td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                        <Col className="gutter-row" span={24}>
                            <div style={{ fontSize: "18px" }}>
                                <div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
                                <div>Определение способа уборки завершено. </div>
                                <div style={{ paddingTop: "15px" }}>Результат:</div>
                            </div>
                            <div style={{ paddingTop: "7px", paddingBottom: "35px" }}>
                                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Наименование приема</th>
                                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                                <th rowSpan="2">Примечание</th>
                                            </tr>
                                            <tr>
                                                <th>Трактор</th>
                                                <th>С.х. машина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td rowSpan={2}>Двухфазная уборка</td>
                                                <td>208 Vario (Fendt)</td>
                                                <td>ЖВЗ-6 </td>
                                                <td>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>-</td>
                                                <td>КЗС-1218 + ПЗ-4,4-3 </td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
                                {(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
                                    Назад
                                </Button>}
                                <Button size='large' type='primary'>
                                    <Link to={"done"}>Повторить</Link>
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                </ConfigProvider>
            </Content>
            {(context && context.contextAnswerContext && context.contextAnswerContext.length > 0) &&
                <Sider theme='light' width={350} style={{ borderLeft: "1px solid #eee", padding: "5px 15px", marginLeft: "25px" }}>
                    <div style={{ paddingBottom: "15px" }}>
                        <Dropdown trigger={['click']} overlay={<Menu>
                            <Menu.Item onClick={backFsm}>
                                <Icofont icon="simple-left" /> Шаг назад
                            </Menu.Item>
                            <Menu.Divider />
                            <Menu.Item onClick={() => {
                                answersClearAll(auth, context, setContext);
                            }}>
                                <Icofont icon="trash" /> Очистить контекст
                            </Menu.Item>
                        </Menu>}>
                            {/* <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                Действия <Icofont icon="simple-down" />
                            </a> */}
                            <Button type='text'>
                                <span className="ant-dropdown-link">Действия <Icofont icon="simple-down" /></span>
                            </Button>
                        </Dropdown>
                    </div>
                    <div>
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Планируется ли внесение удобрений и мелиорантов
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да, планируется</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Какие удобрения/мелиоранты планируется вносить?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Макроудобрения</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Доза вносимых удобрений/мелиорантов
                                </p>
                                <Timeline style={{ paddingTop: "10px" }}>
                                    <Timeline.Item key={1} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                N (в кг.д.в.):
                                            </div>
                                            <div>60</div>
                                        </div>
                                    </Timeline.Item>
                                    <Timeline.Item key={2} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                Р (в кг.д.в.):
                                            </div>
                                            <div>30</div>
                                        </div>
                                    </Timeline.Item>
                                    <Timeline.Item key={3} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                К (в кг.д.в.):
                                            </div>
                                            <div>30</div>
                                        </div>
                                    </Timeline.Item>
                                </Timeline>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Каким образом будут вноситься данные дозы удобрений?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Под основную обработку почвы</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Планируются ли подкормки по вегетации растений?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Планируются</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Выберете варианты и количество подкормок
                                </p>
                                <p style={{ marginBottom: "0em" }}>Вразброс, 1</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Укажите дозы подкормок
                                </p>
                                <Timeline style={{ paddingTop: "10px" }}>
                                    <Timeline.Item key={1} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                N (в кг.д.в.):
                                            </div>
                                            <div>30</div>
                                        </div>
                                    </Timeline.Item>
                                </Timeline>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Произвести подбор соответствующей сельскохозяйственной техники?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Планируется ли внесение удобрений и мелиорантов
                                </p>
                                <p style={{ marginBottom: "0em" }}>Определить целесообразность внесения удобрений и мелиорантов</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Укажите, вносились ли под предшествующую культуру удобрения и мелиоранты?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да, вносились</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Какие удобрения применялись?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Макроудобрения</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Доза вносимых удобрений/мелиорантов
                                </p>
                                <Timeline style={{ paddingTop: "10px" }}>
                                    <Timeline.Item key={1} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                N (в кг.д.в.):
                                            </div>
                                            <div>60</div>
                                        </div>
                                    </Timeline.Item>
                                    <Timeline.Item key={2} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                Р (в кг.д.в.):
                                            </div>
                                            <div>30</div>
                                        </div>
                                    </Timeline.Item>
                                    <Timeline.Item key={3} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                К (в кг.д.в.):
                                            </div>
                                            <div>30</div>
                                        </div>
                                    </Timeline.Item>
                                </Timeline>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Планируется ли внесение органических удобрений?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да, планируется</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Произвести расчет дозы внесения?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Выберите преобладающий тип почвы
                                </p>
                                <p style={{ marginBottom: "0em" }}>Черноземы выщелоченные и типичные</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Введите значения
                                </p>
                                <Timeline style={{ paddingTop: "10px" }}>
                                    <Timeline.Item key={1} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                Содержание гумуса в почве:
                                            </div>
                                            <div>4,7 %</div>
                                        </div>
                                    </Timeline.Item>
                                    <Timeline.Item key={2} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                Глубина пахотного слоя:
                                            </div>
                                            <div>24 см</div>
                                        </div>
                                    </Timeline.Item>
                                    <Timeline.Item key={3} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                Плотность почвы:
                                            </div>
                                            <div>1,2 г/см3</div>
                                        </div>
                                    </Timeline.Item>
                                </Timeline>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Согласно проведенным расчетам, ежегодная убыль органического вещества почвы
                                    составляет <span style={{ textDecoration: "underline" }}>1,1</span> т/га. Для его восполнения выберите планируемый источник повышения
                                    органического вещества почвы
                                </p>
                                <p style={{ marginBottom: "0em" }}>Пожнивно-корневые остатки, <span style={{ textDecoration: "underline" }}>3</span> т/га</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Данные мероприятия не в полной мере компенсируют убыль органического вещества.
                                    Ожидаемая убыль органического вещества
                                    составляет <span style={{ textDecoration: "underline" }}>0,5</span> т/га в год. Планируются ли дополнительные мероприятия?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да, планируются</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Выберите источник дополнительного пополнения органического вещества почвы</p>
                                <p style={{ marginBottom: "0em" }}>Навоз подстилочный</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Произвести расчет дозы внесения?</p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Укажите планируемую дозу внесения</p>
                                <p style={{ marginBottom: "0em" }}><span style={{ textDecoration: "underline" }}>20</span> т/га</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Произвести подбор соответствующей сельскохозяйственной техники?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Планируется ли внесение удобрений и мелиорантов
                                </p>
                                <p style={{ marginBottom: "0em" }}>Определить целесообразность внесения удобрений и мелиорантов</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Укажите, вносились ли под предшествующую культуру удобрения и мелиоранты?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет, не вносились</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируется ли внесение органических удобрений?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет, не планируется</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируется ли внесение минеральных удобрений?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Определить целесообразность внесения минеральных удобрений</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите преобладающий тип почвы
                                </p>
                                <p style={{ marginBottom: "0em" }}>Серые лесные</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите гранулометрический состав почв
                                </p>
                                <p style={{ marginBottom: "0em" }}>Среднесуглинистые почвы</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите среднюю величину ежегодных потерь почвы от эрозионных процессов
                                </p>
                                <p style={{ marginBottom: "0em" }}>до 2,5 т/га</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите назначение возделываемого зерна
                                </p>
                                <p style={{ marginBottom: "0em" }}>продовольственное</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Рекомендуемая доза вносимых удобрений - N66P55K77. Будут ли вносится макроудобрения в предложенных дозах?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Каким образом будут вноситься данные дозы удобрений? 
                                </p>
                                <p style={{ marginBottom: "0em" }}>Под предпосевную культивацию</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируются ли подкормки по вегетации растений?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберете варианты и количество подкормок
                                </p>
                                <p style={{ marginBottom: "0em" }}>Листовая, 1</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите дозы подкормок
                                </p>
                                <Timeline style={{ paddingTop: "10px" }}>
                                    <Timeline.Item key={1} className="small-timeline-dot" color="#378705">
                                        <div style={{ marginBottom: "0em" }}>
                                            <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                N (в кг.д.в.):
                                            </div>
                                            <div>30</div>
                                        </div>
                                    </Timeline.Item>
                                </Timeline>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируемая некорневая (листовая) подкормка будет совмещена с внесением пестицидов?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор соответствующей сельскохозяйственной техники?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируется ли внесение мелиорантов под возделываемую культуру?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Определить целесообразность внесения мелиорантов</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите среднее значение кислотности почвы (PhKCl)
                                </p>
                                <p style={{ marginBottom: "0em" }}>5,7</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Степень кислотности почвы – 5,7. Применение мелиорантов нецелесообразно). Согласны?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите планируемые сроки до посева культуры
                                </p>
                                <p style={{ marginBottom: "0em" }}>Более трех недель</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Способ основной обработки почвы под предшественник
                                </p>
                                <p style={{ marginBottom: "0em" }}>Отвальная</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируется ли применение химических средств защиты посевов
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да, планируется</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                На основе анализа указанных Вами условий 
                                рекомендуется <span style={{ textDecoration: "underline" }}>поверхностная</span> обработка 
                                почвы <span style={{ textDecoration: "underline" }}>на глубину до 12 см</span>. 
                                Произвести подбор соответствующей сельскохозяйственной техники?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите почвообрабатывающее орудие
                                </p>
                                <p style={{ marginBottom: "0em" }}>Дисковые агрегаты (дисковые бороны и дискаторы)</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите планируемые сроки до посева культуры
                                </p>
                                <p style={{ marginBottom: "0em" }}>Одна-три недели</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Способ основной обработки почвы под предшественник
                                </p>
                                <p style={{ marginBottom: "0em" }}>Поверхностная (до 12 см)</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируется ли применение химических средств защиты посевов
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет, не планируется</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                На основе анализа указанных Вами условий 
                                рекомендуется <span style={{ textDecoration: "underline" }}>средняя отвальная</span> обработка 
                                почвы <span style={{ textDecoration: "underline" }}>на глубину до 20-24 см</span>. 
                                Произвести подбор соответствующей сельскохозяйственной техники?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор сельскохозяйственной техники для проведения предпосевной обработки почвы?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите почвообрабатывающий агрегат
                                </p>
                                <p style={{ marginBottom: "0em" }}>КПС-4</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите трактор
                                </p>
                                <p style={{ marginBottom: "0em" }}>МТЗ-82.1</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируется ли протравливание семян?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да, планируется</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Планируется применение химического или биологического протравителя?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Планируется применение химического протравителя</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор сельскохозяйственной техники для проведения предпосевной обработки семян?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите протравитель
                                </p>
                                <p style={{ marginBottom: "0em" }}>ПС-10</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор сельскохозяйственной техники для проведения посева выбранной Вами культуры?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите сеялку
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет в списке</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                По какому параметру будет произведен подбор?
                                </p>
                                <p style={{ marginBottom: "0em" }}>По ширине захвата</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите ширину захвата
                                </p>
                                <p style={{ marginBottom: "0em" }}>5,4</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите трактор
                                </p>
                                <p style={{ marginBottom: "0em" }}>МТЗ-82.1</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Использовать трактор и сельскохозяйственную машину для внесения минеральных удобрений, выбранные Вами раннее?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор сельскохозяйственной техники для проведения посева выбранной Вами культуры?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Удобрения до поля будут доставляться грузовыми автомобилями или тракторами?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Грузовыми автомобилями</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите автомобиль
                                </p>
                                <p style={{ marginBottom: "0em" }}>ГАЗ-САЗ 2507-01</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите разбрасыватель
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет в списке</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                По какому параметру будет произведен подбор?
                                </p>
                                <p style={{ marginBottom: "0em" }}>По грузоподъемности</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите грузоподьемность
                                </p>
                                <p style={{ marginBottom: "0em" }}>800 кг</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите трактор
                                </p>
                                <p style={{ marginBottom: "0em" }}>МТЗ-82.1</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор сельскохозяйственной техники для проведения ранневесеннего боронования озимых?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите фазу развития культуры
                                </p>
                                <p style={{ marginBottom: "0em" }}>Кущение (весной)</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите вредный объект
                                </p>
                                <p style={{ marginBottom: "0em" }}>Подмаренник цепкий </p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите количество вредных объектов на 1м2
                                </p>
                                <p style={{ marginBottom: "0em" }}>10</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Еще имеются вредные объекты?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите фазу развития культуры
                                </p>
                                <p style={{ marginBottom: "0em" }}>Колошение</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите вредный объект
                                </p>
                                <p style={{ marginBottom: "0em" }}>Пьявица</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Укажите количество вредных объектов на 1 стебель
                                </p>
                                <p style={{ marginBottom: "0em" }}>0,2</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Еще имеются вредные объекты?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                По результатам анализа вредных объектов, Вам рекомендуется произвести 
                                обработку против <span style={{ textDecoration: "underline" }}>подмаренника цепкого</span>. Вы согласны?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор препарата?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выбран <span style={{ textDecoration: "underline" }}>Фенизан</span>. 
                                Норма внесение – <span style={{ textDecoration: "underline" }}>0,2</span> л/га. 
                                Расход рабочей жидкости – <span style={{ textDecoration: "underline" }}>300</span> л/га. Согласны?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Произвести подбор соответствующей сельскохозяйственной техники?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Препараты и вода до поля будут доставляться грузовыми автомобилями или тракторами?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Грузовыми автомобилями</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите автомобиль
                                </p>
                                <p style={{ marginBottom: "0em" }}>ГАЗ-САЗ 2507-01</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите емкость
                                </p>
                                <p style={{ marginBottom: "0em" }}>Кассета 4000 литров</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите опрыскиватель
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет в списке</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                По какому параметру будет произведен подбор?
                                </p>
                                <p style={{ marginBottom: "0em" }}>По ширине захвата</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите ширину захвата
                                </p>
                                <p style={{ marginBottom: "0em" }}>24 м</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите трактор
                                </p>
                                <p style={{ marginBottom: "0em" }}>МТЗ-82.1</p>
                            </Timeline.Item>
                        </Timeline> */}
                        {/* <Timeline>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Укажите равномерность созревания посевов
                                </p>
                                <p style={{ marginBottom: "0em" }}>Очень неравномерное созревание </p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Произвести подбор сельскохозяйственной техники для проведения уборки выбранной Вами культуры?
                                </p>
                                <p style={{ marginBottom: "0em" }}>Да</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    Выберите тип жатки
                                </p>
                                <p style={{ marginBottom: "0em" }}>Жатка валковая</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите трактор
                                </p>
                                <p style={{ marginBottom: "0em" }}>Нет в списке</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                    По какому параметру будет произведен подбор?
                                </p>
                                <p style={{ marginBottom: "0em" }}>По мощности</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите мощность, л.с
                                </p>
                                <p style={{ marginBottom: "0em" }}>81</p>
                            </Timeline.Item>
                            <Timeline.Item key={1} color={"green"}>
                                <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                Выберите подборщик
                                </p>
                                <p style={{ marginBottom: "0em" }}>ПЗ-4,4-3</p>
                            </Timeline.Item>
                        </Timeline> */}
                        <Timeline>
                            {(context && questions) && JSXMap(questions, (e, idx) => (
                                <Timeline.Item key={idx} color={(funcs.findIndex(s => s.fsmFunction.questionID === e.question.ID) < 0) ? "green" : "red"}>
                                    <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                        {_.get(e, "question.shortTitle") || _.get(e, "question.title")}
                                    </p>
                                    {(e.answer && e.question.answerTypeID !== 9) &&
                                        <p style={{ marginBottom: "0em" }}>{e.answer.answerDisplay}</p>
                                    }
                                    {(e.answer && e.question.answerTypeID === 9) &&
                                        <Timeline style={{ paddingTop: "10px" }}>

                                            {JSXMap(e.answer, (a, idx) =>
                                                <Timeline.Item key={idx} className="small-timeline-dot" color="#378705">
                                                    <div style={{ marginBottom: "0em" }}>
                                                        <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                            {a.answerName}:
                                                        </div>
                                                        <div>{a.answerDisplay}</div>
                                                    </div>
                                                </Timeline.Item>
                                            )}
                                        </Timeline>
                                    }
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    </div>
                </Sider>}
        </Layout>
    </>);
}
